<template>
  <div>
    <el-dialog :title="form.id?'编辑':'新增'" :visible.sync="formVisible" :close-on-click-modal="false" top="3vh" width="1000px">
      <div class="content" :style="'height: ' + windowHeight + 'px; overflow-y: auto;'">
        <div class="reimbursement">
          <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="130px">
            <el-form-item label="闯关阶段：" prop="stageNum" class="width100">
              <el-input v-model="form.stageNum" placeholder="请输入闯关阶段" />
            </el-form-item>
            <el-form-item label="学习阶段时间：" prop="dateTime" class="width100">
              <el-date-picker v-model="form.dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="闯关内容：" required class="width100">
              <el-checkbox v-model="checked1" lable="1">课程</el-checkbox>
              <el-checkbox v-model="checked2" lable="2">情景练习</el-checkbox>
            </el-form-item>
            <template v-if="checked1">
              <el-form-item label="闯关课程：" class="width100 is-required">
                <el-button type="primary" icon="el-icon-plus" size="small" @click="handleCourse">添加课程</el-button>
              </el-form-item>
              <el-table :data="courseList" v-if="courseList.length > 0">
                <el-table-column label="课程名称" prop="name" align="center" />
                <el-table-column label="课程类型" prop="" align="center">
                  <template slot-scope="{row}">
                    {{row.type === 1?'图文课程':(row.type === 2?'视频课程':'')}}
                  </template>
                </el-table-column>
                <el-table-column label="章节节数" prop="chapterNum" align="center" />
                <el-table-column label="操作" prop="name" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" @click="handleDeleteCourse(scope)">移除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </template>
            <template v-if="checked2">
              <el-form-item label="情景练习：" class="width100 is-required">
                <el-button type="primary" icon="el-icon-plus" size="small" @click="handleSubject">添加题目</el-button>
              </el-form-item>
              <el-table :data="subjectList" v-if="subjectList.length > 0">
                <el-table-column label="问题内容" prop="questionContent" align="center" show-overflow-tooltip />
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" @click="handleDeleteSubject(scope)">移除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </template>
            <el-form-item label="闯关模式：" prop="type" class="width100">
              <el-radio-group v-model="form.type">
                <el-radio :label="1">考试闯关</el-radio>
                <el-radio :label="2">学习闯关</el-radio>
              </el-radio-group>
            </el-form-item>
            <template v-if="form.type === 1">
              <el-form-item label="试卷分类：" prop="topicClassificationId" class="width100">
                <el-select v-model="form.topicClassificationId" placeholder="请选择" clearable size="small">
                  <el-option v-for="(item,index) in topicClassOptions" :key="index" :label="item.value" :value="item.key"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="考试题数：" prop="examNum">
                <el-input v-model="form.examNum" placeholder="请输入考试题数" />
              </el-form-item>
              <el-form-item label="单题分数：" prop="examSingleScore">
                <el-input v-model="form.examSingleScore" placeholder="请输入每道题得分">
                  <i class="el-input__icon" slot="suffix">分</i>
                </el-input>
              </el-form-item>
              <el-form-item label="总分：">
                <el-input v-model="examTotalScore" placeholder="根据单题分数和考试题数算出总分" disabled>
                  <i class="el-input__icon" slot="suffix">分</i>
                </el-input>
              </el-form-item>
              <el-form-item label="考试达标分数：" prop="achievementScore">
                <el-input v-model="form.achievementScore" placeholder="请输入考试达标分数" />
              </el-form-item>
              <el-form-item label="考试学分：" prop="examCredits">
                <el-input v-model="form.examCredits" placeholder="请输入考试完成后获得的学分" />
              </el-form-item>
              <el-form-item label="是否能看答案：" prop="isLookSolution">
                <el-select v-model="form.isLookSolution" placeholder="请选择">
                  <el-option label="允许查看" :value="1"></el-option>
                  <el-option label="不允许查看" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="考试次数：" prop="examOrder">
                <el-input v-model="form.examOrder" placeholder="请输入考试次数" />
              </el-form-item>
              <el-form-item label="考试时长：" prop="examDuration">
                <el-input v-model="form.examDuration" placeholder="请输入考试时间长">
                  <i class="el-input__icon" slot="suffix">分钟</i>
                </el-input>
              </el-form-item>
              <el-form-item label="考试规则：" prop="examRules" class="width100">
                <el-select v-model="form.examRules" placeholder="请选择">
                  <el-option label="学习完考" :value="1"></el-option>
                  <el-option label="不限制" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </template>

            <el-form-item label="状态：" prop="state" class="width100">
              <el-switch v-model="form.state" :active-value="true" :inactive-value="false"></el-switch> {{form.state?'启用':'禁用'}}
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="formVisible = false">取消</el-button>
            <el-button type="primary" @click="doCreate()">确认</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <exercises-vue ref="exercisesVue" @created="parentSubject" />
    <course-vue ref="courseVue" @created="parentCourse" />
  </div>
</template>

<script>
import courseTopicClassificationApi from '@/api/course/courseTopicClassification'
import courseSubjectBarrierStageApi from '@/api/course/courseSubjectBarrierStage'
import exercisesVue from './exercises.vue'
import courseVue from './course.vue'
import { accMul } from '@/utils/index'
function initFormBean() {
  const formBean = {
    type: null,
    topicClassificationId: null,
    achievementScore: null,
    examCredits: null,
    examNum: null,
    examRules: null,
    isLookSolution: null,
    examOrder: null,
    examDuration: null,
    stageNum: null,
    examSingleScore: null,
    examTotalScore: null,
    state: false,
    courseScenarioExerciseList: [],
    dateTime: []
  }
  return formBean
}

export default {
  props: ['rowItem'],
  components: { exercisesVue, courseVue },
  data() {
    return {
      courseList: [],
      subjectList: [],
      checked1: false,
      checked2: false,
      topicClassOptions: [],
      form: initFormBean(),
      formVisible: false,
      formRules: {
        stageNum: [{ required: true, message: '请输入闯关阶段', trigger: 'blur' },
        { pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }],
        type: [{ required: true, message: '请选择闯关模式', trigger: 'change' }],
        dateTime: [{ required: true, message: '请选择学习阶段时间', trigger: 'change' }],
        topicClassificationId: [{ required: true, message: '请选择试卷分类', trigger: 'change' }],
        achievementScore: [{ required: true, message: '请输入考试达标分数', trigger: 'blur' },
        { pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }],
        examCredits: [{ required: true, message: '请输入考试完成后获得的学分', trigger: 'blur' },
        { pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }],
        examNum: [{ required: true, message: '请输入考试题数', trigger: 'blur' },
        { pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }],
        examRules: [{ required: true, message: '请选择考试规则', trigger: 'change' }],
        isLookSolution: [{ required: true, message: '请选择是否能看答案', trigger: 'change' }],
        examOrder: [{ required: true, message: '请输入考试次数', trigger: 'blur' },
        { pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }],
        examDuration: [{ required: true, message: '请输入考试时间长', trigger: 'blur' },
        { pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }],
        examSingleScore: [{ required: true, message: '请输入每道题得分', trigger: 'blur' },
        { pattern: /^\d+(\.\d{1,2})?$/, message: '必须为数字值', trigger: 'blur' }],
        state: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      isRepSub: false
    }
  },
  created() {
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    this.windowHeight = windowHeight - 150;
    courseTopicClassificationApi.fetchOptions().then(({ data }) => this.topicClassOptions = data)
  },
  computed: {
    examTotalScore() {
      let score = null
      let { examNum, examSingleScore } = this.form
      if (examNum && examSingleScore) {
        score = accMul(examNum, examSingleScore)
        this.form.examTotalScore = score
      }
      return score
    }
  },
  methods: {
    /**
     * 重置表单
     */
    resetForm() {
      this.subjectList = []
      this.courseList = []
      this.checked1 = false;
      this.checked2 = false;
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.resetForm()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row };
      this.calcEditData()
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    calcEditData() {
      let { courseSubjectList, courseScenarioExerciseList, startTime, endTime } = this.form;
      if (courseSubjectList.length > 0) {
        this.courseList = courseSubjectList
        this.checked1 = true
      }
      if (courseScenarioExerciseList.length > 0) {
        this.subjectList = courseScenarioExerciseList
        this.checked2 = true
      }
      if (startTime && endTime) this.$set(this.form, 'dateTime', [startTime, endTime])
      else this.$set(this.form, 'dateTime', [])
    },
    calcParams() {
      let params = JSON.parse(JSON.stringify(this.form))
      if (params.dateTime && params.dateTime.length > 0) {
        params.startTime = params.dateTime[0]
        params.endTime = params.dateTime[1]
      }
      delete params.dateTime
      if (this.checked1 && this.courseList.length) {
        params.courseSubjectList = this.courseList.map(obj => obj.id)
      }
      if (this.checked2 && this.subjectList.length) {
        params.courseScenarioExerciseList = this.subjectList.map(obj => obj.id)
      }
      return params
    },
    doCreate() {
      let { courseList, subjectList, checked1, checked2 } = this;
      if (checked1 && !courseList.length) return this.$message.error('请添加课程')
      if (checked2 && !subjectList.length) return this.$message.error('请添加情景练习题目')
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let params = this.calcParams()
          params.barrierId = this.rowItem.id
          params.achievementScore = +params.achievementScore || 0
          params.examCredits = +params.examCredits || 0
          params.examNum = +params.examNum || 0
          params.examRules = +params.examRules || 0
          params.isLookSolution = +params.isLookSolution || 1
          params.stageNum = params.stageNum || 0
          params.topicClassificationId = +params.topicClassificationId || 0
          params.examDuration = +params.examDuration || 0
          params.examOrder = +params.examOrder || 0
          this.submitGoods(params)
        }
      });
    },
    submitGoods(params) {
      if (this.isRepSub) return
      this.isRepSub = true
      if (params.id > 0) {
        courseSubjectBarrierStageApi.update(params).then((data) => {
          this.postCallback(data)
        }).catch(res => {
          this.isRepSub = false
        });
      } else {
        courseSubjectBarrierStageApi.create(params).then((data) => {
          this.postCallback(data)
        }).catch(res => {
          this.isRepSub = false
        });
      }
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.tabType = 1
      this.$emit('created')
    },
    // 添加情景练习
    handleSubject() {
      this.$refs.exercisesVue.handleSubject()
    },
    parentSubject(arr) {
      this.subjectList = arr
    },
    handleDeleteSubject(scope) {
      this.subjectList.splice(scope.$index, 1)
    },
    //添加闯关课程
    handleCourse() {
      this.$refs.courseVue.handleCourse()
    },
    parentCourse(arr) {
      this.courseList = arr
    },
    handleDeleteCourse(scope) {
      this.courseList.splice(scope.$index, 1)
    },
  }
}
</script>
<style lang="scss" scoped>
.mt {
  margin-top: 10px;
}
.dialog-footer {
  position: absolute;
  bottom: 5px;
  text-align: right;
  right: 20px;
}

::v-deep.el-tabs {
  height: 100%;
  .el-tabs__content {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 15px;
  }
}
.rig-btn {
  float: right;
}
::v-deep .el-dialog__body {
  padding: 10px 0;
}
.reimbursement {
  padding: 0 20px;
}
.flexs {
  display: flex;
  align-items: center;
  .el-radio {
    margin-left: 5px;
  }
}
/* 修改滚动条整体样式 */
::-webkit-scrollbar {
  width: 6px;
  /* 滚动条宽度 */
  background-color: #f1f1f1;
  /* 滚动条背景色 */
}

/* 修改滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #d2d2d2;
  /* 滑块颜色 */
  border-radius: 4px;
  /* 滑块圆角 */
}

/* 修改滚动条轨道样式 */
::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* 轨道背景色 */
}

/* 修改滚动条角落样式 */
::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
  /* 角落背景色 */
}
::v-deep .stage-box {
  .el-form-item__label {
  }
}

.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}

.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
::v-deep .el-select {
  width: 100%;
}
.title-box {
  margin-bottom: 10px;
  margin-right: 24px;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 30px;
    &::before {
      content: '';
      position: absolute;
      left: 20px;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
    cursor: pointer;
  }
}
::v-deep .el-cascader {
  width: 100%;
}
::v-deep .el-checkbox {
  margin-right: 10px;
}
.lab {
  font-size: 14px;
  color: #8f8e8e;
  border-radius: 4px;
  padding: 0 18px;
  display: inline-block;
  border: 1px solid #c5c5c5;
  margin: 5px;
  position: relative;
  cursor: pointer;
  &.active {
    background: #5dbde7;
    color: #fff;
    border-color: #5dbde7;
  }
  i {
    position: absolute;
    left: 0;
    top: 0;
  }
}
.full-box {
  display: flex;
  .full-icon {
    display: flex;
    align-items: center;
    height: 32px;
    i {
      font-size: 18px;
      font-weight: bold;
      color: #5dbde7;
      cursor: pointer;
      padding-left: 5px;
    }
  }
}
.item-box {
  margin-bottom: 10px;
  .el-icon-delete {
    font-size: 18px;
    color: #d81e06;
    cursor: pointer;
  }
}
.el-table {
  margin-bottom: 10px;
}
</style>
